<template>
  <Home />
</template>

<script>
import Home from '@/views/Home.vue'
export default { name: 'App', components: { Home } }
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL@20,400,0');
:root { --ink:#f7f8fa; --muted:#9da3aa; --line:rgba(255,255,255,.12); --line-strong:rgba(255,255,255,.22); --page-dark:#050505; --page-light:#f7f8f8; --surface:var(--page); --accent:#5ab8ff; --page:var(--page-dark); }
:root { --content-max-width:1304px; }
:root[data-theme='light'] { --page:var(--page-light); }
* { box-sizing:border-box; margin:0; padding:0; }
html { scroll-behavior:smooth; background:var(--page); }
/* Keep native scrolling, but reduce the viewport scrollbar to a quiet hairline. */
html { --scroll-thumb:rgba(255,255,255,.22); scrollbar-width:thin; scrollbar-color:var(--scroll-thumb) transparent; }
html[data-theme='light'] { --scroll-thumb:rgba(17,20,23,.24); }
@supports selector(::-webkit-scrollbar) {
  html { scrollbar-width:auto; scrollbar-color:auto; }
  html::-webkit-scrollbar { width:3px; height:3px; }
  html::-webkit-scrollbar-track { background:transparent; }
  html::-webkit-scrollbar-thumb { background:var(--scroll-thumb); border-radius:999px; }
  html::-webkit-scrollbar-thumb:hover { background:var(--muted); }
  html::-webkit-scrollbar-button { display:none; width:0; height:0; }
  html::-webkit-scrollbar-corner { background:transparent; }
}
html,body { transition:background-color .9s cubic-bezier(.4,0,.2,1); }
@media (prefers-reduced-motion: reduce) { html { scroll-behavior:auto; } }
body { min-width:320px; color:var(--ink); background:var(--page); font-family:'Manrope','Noto Sans SC','Microsoft YaHei',system-ui,sans-serif; text-rendering:geometricPrecision; -webkit-font-smoothing:antialiased; overflow-x:hidden; }
body.menu-open { overflow:hidden; }
body.intro-locked { overflow:hidden; }
button,input,textarea { font:inherit; }
button,a { -webkit-tap-highlight-color:transparent; }
a { color:inherit; }
::selection { color:#050505; background:var(--accent); }
</style>
